import React from 'react'
import PhoneNumber from 'awesome-phonenumber'
import { ValidatorForm, ValidatorComponent } from 'react-form-validator-core'
import FileSelector from './FileSelector'
import './Validators.css'

import loadable from '@loadable/component'
const LoadableDatePicker = loadable(() => import('./DatePicker'))

ValidatorForm.addValidationRule('isNotDefault', (value) => {
  if (value === 'default' || !value) {
      return false;
  }
  return true;
});
ValidatorForm.addValidationRule('isPhoneNumber', (value) => {
  const phoneNumber = new PhoneNumber(value || '', 'US')
  return phoneNumber.isValid()
});
ValidatorForm.addValidationRule('hasFile', (value) => {
  return !!value
});

const errorText = function() {
  const { isValid } = this.state
  return (
    <div className="text-input-error">
      {!isValid && (
        <p className="text-input-error-message">{this.getErrorMessage()}</p>
      )}
    </div>
  )
}
const errorTextOverride = (text) => {
  if (!text) {
    return null
  }
  return (
    <div className="text-input-error">
      <p className="text-input-error-message">{text}</p>
    </div>
  )
}
export class TextValidator extends ValidatorComponent {
  setErrorMessage(errorMessage) {
    this.setState({
      errorMessage
    })
  }
  renderValidatorComponent() {
    const { 
      errorMessages, 
      validators, 
      requiredError, 
      validatorListener, 
      className, 
      placeholder, 
      value,
      ...rest 
    } = this.props
    const { isValid, errorMessage } = this.state
    const isRequired = validators.includes('required')
    return (
      <div className="text-input-wrap">
        <input
          {...rest}
          placeholder={(`${placeholder} ${isRequired ? '*' : ''}`) || ''}
          className={`text-input ${className || ''} ${isValid ? '' : 'missing'}`}
          value={value || ''}
        />
        {errorTextOverride(errorMessage) || errorText.call(this)}
      </div>
    )
  }
}
export class TextAreaValidator extends ValidatorComponent {
  renderValidatorComponent() {
    const { 
      errorMessages, 
      validators, 
      requiredError, 
      validatorListener, 
      className, 
      placeholder,
      value, 
      ...rest 
    } = this.props
    const { isValid } = this.state
    const isRequired = validators.includes('required')
    return (
      <div className="textarea-wrap">
        <textarea
          {...rest}
          placeholder={(`${placeholder} ${isRequired ? '*' : ''}`) || ''}
          className={`text-input ${className || ''} ${isValid ? '' : 'missing'}`}
          value={value || ''}
        />
        {errorText.call(this)}
      </div>
    )
  }
}
export class SelectValidator extends ValidatorComponent {
  renderValidatorComponent() {
    const { 
      errorMessages, 
      validators, 
      validatorListener, 
      className, 
      placeholder, 
      options, 
      value,
      ...rest 
    } = this.props
    const { isValid } = this.state
    const isRequired = validators.includes('required') || validators.includes('isNotDefault')
    return (
      <div className="select-wrap">
        <select 
          className={`select ${className || ''} ${isValid ? '' : 'missing'}`}
          value={value || 'default'}
          {...rest}
        >
          <option className="select-option-default" value="default" disabled>
            {`${placeholder} ${isRequired ? '*' : ''}`}
          </option>
          {options.map(option => {
            return (
              <option
                key={option.id}
                name={option.id}
                value={option.id}
                className="hc-form-option"
              >
                {option.text}
              </option>
            )
          })}
        </select>
        <div className="select-arrow-wrap">
          <svg
            width="18"
            height="9"
            viewBox="0 0 18 8.9"
            className="select-arrow"
          >
            <path
              fill="none"
              className="select-arrow-path"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M.6.8l9 6.8L17.4.8"
              data-name="Path 81"
            ></path>
          </svg>
        </div>
        {errorText.call(this)}
      </div>
    )
  }
}
export class DateValidator extends ValidatorComponent {
  renderValidatorComponent() {
      const { 
        errorMessages, 
        validators, 
        requiredError, 
        validatorListener, 
        className, 
        wrapperClass,
        placeholder, 
        value, 
        minDateOffset,
        maxDateOffset,
        extraProps,
        ...rest 
      } = this.props
      const { isValid } = this.state
      const isRequired = validators.includes('required')
      return (
        <div className={`date-picker-wrap ${wrapperClass || ''}`}>
          <LoadableDatePicker
            className={`date-picker ${className || ''}`}
            wrapperClassName={`date-picker-wrapper ${isValid ? '' : 'missing'}`}
            placeholderText={`${placeholder} ${isRequired ? '*' : ''}`}
            popperPlacement="bottom-center"
            popperModifiers={{
              preventOverflow: {
                enabled: false,
                escapeWithReference: true,
                boundariesElement: "viewport"
              }
            }}
            autoComplete="none"
            preventOpenOnFocus
            selected={value}
            minDate={minDateOffset !== undefined ? Date.now() + minDateOffset : null}
            maxDate={maxDateOffset !== undefined ? Date.now() + maxDateOffset : null}
            {...rest}
            {...extraProps}
          />
          <i className="material-icons-round">event</i>
          {errorText.call(this)}
        </div>
      )
  }
}
export class FileValidator extends ValidatorComponent {
  renderValidatorComponent() {
      const { 
        errorMessages, 
        validators, 
        requiredError, 
        validatorListener, 
        className, 
        placeholder, 
        accept,
        value,
        label,
        name,
        onChange,
        ...rest 
      } = this.props
      const { isValid } = this.state
      return (
        <div className="file-input-wrap">
          <FileSelector
            name={name}
            className={className}
            accept={accept}
            label={label}
            onChange={onChange}
            {...rest}
          />
          {errorText.call(this)}
        </div>
      )
  }
}
